/* eslint-disable */
const FilterFields = {
  alldays: Array.from({ length: 30 }, (_, i) => i + 1).map(day => ({
    label: `${day}`,
    value: `${day}`
  })),
  ageRange: Array.from({ length: 110 }, (_, i) => i + 1).map(day => ({
    label: `${day}`,
    value: `${day}`
  })),
  dueRange: Array.from({ length: 120 }, (_, i) => i + 1).map(day => ({
    label: `${day}`,
    value: `${day}`
  })),
  stateToFilterIdMapping: {
    apptDaysFrom: "5",
    apptStatus: "6",
    apptFacility: "7",
    apptProvider: "8",
    apptType: "9",
    dueRangeStart: "3",
    dueRangeEnd: "4",
    pastDueMin: "10",
    pastDueMax: "11",
    ageStart: "1",
    ageEnd: "2"
  },
  filterIdToStateMapping: {
    6: "apptStatus",
    5: "apptDaysFrom",
    7: "apptFacility",
    8: "apptProvider",
    9: "apptType",
    3: "dueRangeStart",
    4: "dueRangeEnd",
    10: "pastDueMin",
    11: "pastDueMax",    
    1: "ageStart",
    2: "ageEnd"
  },
  validations: {
    1: [
      "5", "6", "7", "8", "9"
    ],
    2: [
      "3", "4","10","11"
    ],
    3: [
      "1", "2"
    ],
  }
};

export default FilterFields;
